import {
  TRYHACKME_ROOM_URL,
  LINKEDIN_SHARE_URL,
  TWITTER_SHARE_URL,
  FACEBOOK_SHARE_URL,
} from './completion-modal.constants';
import { CampaignProps, SocialName } from './completion-modal.types';

export const generateRoomLinkWithCampaign = (roomCode: string, campaign: CampaignProps, customLink?: string) => {
  let baseLink = customLink ?? TRYHACKME_ROOM_URL + roomCode;
  const utmSource = campaign?.utm_source;
  const utmCampaign = campaign?.utm_campaign;
  const utmMedium = campaign?.utm_medium;

  if (utmSource || utmCampaign || utmMedium) {
    baseLink += `?utm_campaign=${utmCampaign}&utm_medium=${utmMedium}`;
    if (utmSource) baseLink += `&utm_source=${utmSource}`;
  }

  return baseLink;
};

export const generateSocialMediaShareLink = (
  socialMedia: SocialName,
  roomCode: string,
  campaign: CampaignProps,
  customLink?: string,
) => {
  const baseLink = generateRoomLinkWithCampaign(roomCode, campaign, customLink);

  let shareUrl: URL;

  switch (socialMedia) {
    case SocialName.LINKEDIN: {
      shareUrl = new URL(LINKEDIN_SHARE_URL);
      shareUrl.searchParams.append('url', baseLink);
      break;
    }
    case SocialName.TWITTER: {
      shareUrl = new URL(TWITTER_SHARE_URL);
      shareUrl.searchParams.append('url', baseLink);
      break;
    }
    case SocialName.FACEBOOK: {
      shareUrl = new URL(FACEBOOK_SHARE_URL);
      shareUrl.searchParams.append('u', baseLink);
      break;
    }
    default: {
      throw new Error('Invalid social media');
    }
  }

  return shareUrl.toString();
};
